import styled from 'styled-components';
import { CarGalleryStyled } from '../../CarGalleryStyled';
import { rem } from 'polished';

export const CarGalleryStyledOV = styled(CarGalleryStyled)`
    .button-wrapper {
        button {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            line-height: ${({ theme }) => theme.lineHeights.h4};
            text-transform: uppercase;
            color: ${({ theme }) => theme.colors.grey11};
            opacity: 0.5;

            &.active {
                font-weight: 700;
                color: ${({ theme }) => theme.colors.black};
                cursor: default;
                border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
                opacity: 1;
            }

            &:first-child {
                margin-right: ${rem(20)};
            }
        }
    }
`;
